import { toast } from "react-hot-toast";

const SubscriptionCustomToast = (message) => {
  toast.success(message, {
    style: {
      background: "#FFF9CE",
      color: "black",
    },
    icon: false,
  });
};

export default SubscriptionCustomToast;
